import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";

const InactiveSessionLogoutPopup = ({ showPopup, handleStayLoggedIn, handleLogout, logoutLoading }) => {
  const [secondsLeft, setSecondsLeft] = useState(15);

  useEffect(() => {
    if (!showPopup) return;

    const endTime = Date.now() + 15000; // 15 seconds from now

    const updateCountdown = () => {
      const diff = Math.max(0, Math.ceil((endTime - Date.now()) / 1000));
      setSecondsLeft(diff);
      if (diff <= 0) {
        handleLogout();
      }
    };

    updateCountdown(); // set immediately
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval);
  }, [showPopup, handleLogout]);

  return (
    <Modal
      show={showPopup}
      onHide={handleLogout}
      backdrop="static"
      keyboard={false}
      centered
      className="FormPop session-timeout-modal"
    >
      <Modal.Header>
        <Modal.Title>Session Timeout</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="justify-content-center">
          <Col lg="12" className="main-content text-center">
            <p>
              You've been inactive for a while. For security reasons, you'll be logged out in{" "}
              <strong>{secondsLeft} seconds</strong>.
            </p>
            <p>If you wish to continue your session, click "Stay Logged In".</p>
            <div className="d-flex justify-content-center gap-3 mt-4">
              <Button
                className="commonBtn btnSm"
                variant="secondary"
                onClick={handleStayLoggedIn}
              >
                Stay Logged In
              </Button>
              <Button
                className="btnSm"
                variant="danger"
                onClick={handleLogout}
                disabled={logoutLoading}
              >
                {logoutLoading ? "Logging out..." : "Logout Now"}
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default InactiveSessionLogoutPopup;
